import * as Yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js/max';
import { COUNTRY } from '../../../constants';

export const editInvoiceContactCompleteValidationSchema = Yup.object({
  name: Yup
    .string()
    .trim()
    .required('Il campo è obbligatorio'),
  email: Yup
    .string()
    .required('Il campo è obbligatorio')
    .trim()
    .email('Inserisci un indirizzo email valido'),
  fiscalCode: Yup
    .string()
    .required('Il campo è obbligatorio')
    .length(16, 'Il codice fiscale è composto da 16 caratteri.'),
  phoneNumber: Yup
    .string()
    .test('isValid', 'Inserisci un numero di telefono valido', (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY)),
  address: Yup.object().shape({
    normalizedAddress: Yup.object({
      description: Yup.string().required('Il campo è obbligatorio'),
    }).required('Il campo è obbligatorio'),
  }),
});

export const editInvoiceContactMinimalValidationSchema = Yup.object().shape({
  name: Yup
    .string()
    .trim()
    .required('Il campo è obbligatorio'),
  email: Yup
    .string()
    .trim()
    .email('Inserisci un indirizzo email valido')
    .when('phoneNumber', {
      is: (phoneNumber: string) => !phoneNumber || phoneNumber.length === 0,
      then: (schema) => schema.required('Devi inserire numero di telefono o email'),
      otherwise: (schema) => schema.notRequired(),
    }),
  fiscalCode: Yup
    .string()
    .trim()
    .length(16, 'Il codice fiscale è composto da 16 caratteri.'),
  phoneNumber: Yup
    .string()
    .test('isValid', 'Inserisci un numero di telefono valido', (value: string | undefined) => !value || isValidPhoneNumber(value, COUNTRY))
    .when('email', {
      is: (email: string) => !email || email.length === 0,
      then: (schema) => schema.required('Devi inserire numero di telefono o email'),
      otherwise: (schema) => schema.notRequired(),
    }),
}, [['email', 'phoneNumber']]);
